import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ImageDumbView from '../Image';
import LiteratureDumbView from '../Literature';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType, getBlurredThumbStyles } from '../../_helpers';
import s from './Premium.scss';
var PremiumDumbView = function (_a) {
    var withCSSBlur = _a.withCSSBlur, dumboProps = __rest(_a, ["withCSSBlur"]);
    var deviation = dumboProps.deviation, width = dumboProps.width, height = dumboProps.height, className = dumboProps.className;
    var deviationType = getDeviationType(deviation);
    if (deviationType === DeviationTypes.IMAGE) {
        if (!withCSSBlur) {
            return React.createElement(ImageDumbView, __assign({}, dumboProps));
        }
        return (React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['css-blurred-thumb'] },
                React.createElement(ImageDumbView, __assign({}, dumboProps)))));
    }
    if (deviationType === DeviationTypes.LITERATURE) {
        return React.createElement(LiteratureDumbView, __assign({}, dumboProps));
    }
    return (React.createElement("div", { className: classnames(s['root'], className), style: {
            width: width || height,
            height: height || width,
        } },
        React.createElement("div", { className: s['cdn-blurred-thumb'], style: getBlurredThumbStyles(deviation) })));
};
PremiumDumbView.displayName = 'PremiumDumbView';
export default PremiumDumbView;
//# sourceMappingURL=Premium.js.map